import { useBackendApi } from './backendApi';

export function useDetailFieldSetsAdminService() {
  const backendApi = useBackendApi();

  const getDetailFieldSetsByTeamId = async (teamId: number) => {
    return backendApi.get(`/manager/teams/${teamId}/detailfieldsets`);
  }

  return {
    getDetailFieldSetsByTeamId,
  }
}
